import React, { useState, useEffect } from "react";
import { Modal, Form, Input, Button, message, Select, DatePicker } from "antd";
import "./style.scss";
import { useSelector } from "react-redux";
import TestimonialService from "../../services/TestimonialService";
import DiscountService from "../../services/DiscountService";
import moment from "moment";

const { Option } = Select;

export default function AddDiscountode(props) {
  const formRef = React.createRef();
  const [form] = Form.useForm();
  const [lat, setLat] = useState("");
  const [long, setLong] = useState();
  const [cusines, setCusines] = useState(["FLAT", "ABSOLUTE", "PERCENTAGE"]);
  const [cusineId, setCusinesId] = useState();

  const adminRestaurant = useSelector((state) => state.admin);

  useEffect(() => {
    if (props.isEdit) {
      formRef.current.setFieldsValue({
        code: props.updateDiscount.code,
        nvalid_from: moment(
          new Date(props.updateDiscount.valid_from),
          "YYYY-MM-DD"
        ),
        valid_till: moment(
          new Date(props.updateDiscount.valid_till),
          "YYYY-MM-DD"
        ),
        is_active: props.updateDiscount.is_active,
      });
      setLat(props.updateDiscount.lat);
      setLong(props.updateDiscount.long);
      setCusinesId(props.updateDiscount.cuisine_id);
    }
  }, [props]);

  useEffect(() => {
    getcusines();
  }, []);
  const getcusines = async () => {
    const data = await TestimonialService.getCusines();
    setCusines(data.cuisines);
  };

  const addAdmin = async (values) => {
    const testimonials = {
      code: values.code,
      valid_from: values.valid_from,
      valid_till: values.valid_till,

      discount_id: +props.discountId,
      // restaurant_id: adminRestaurant,
      is_active: values.is_active,
    };

    if (props.isEdit) {
      await DiscountService.updateDiscountsCode(
        testimonials,
        props.updateDiscount && props.updateDiscount.id
      );
      message.success("Updated Successfully");
    } else {
      await DiscountService.addDiscountsCode(testimonials);
      message.success("Added Successfully");
    }
    props.closeModal(false);
  };

  return (
    <Modal
      title={props.isEdit ? "Update Restaurant" : "Add Restaurant"}
      visible={props.modalOpen}
      footer={null}
      onCancel={() => props.closeModal(false)}
    >
      <Form ref={formRef} form={form} onFinish={addAdmin} layout="vertical">
        <Form.Item
          name="code"
          label="Code"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="valid_from"
          label="Valid From"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <DatePicker format="YYYY-MM-DD" />
        </Form.Item>
        <Form.Item
          name="valid_till"
          label="Valid Till"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <DatePicker format="YYYY-MM-DD" />
        </Form.Item>

        {/* <Form.Item
          name="cuisine_id"
          label="Cuisine"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select defaultValue={cusineId} style={{ width: 120 }} >
            {cusines && cusines.map(item =>
              <Option value={item.id}>{item.name}</Option>)}
      
     
     
    </Select>
        </Form.Item> */}

        <Form.Item
          name="is_active"
          label="is_active"
          rules={[
            {
              required: true,
            },
          ]}
        >
          <Select defaultValue={true}>
            <Option value={true}>true</Option>
            <Option value={false}>false</Option>
          </Select>
        </Form.Item>

        <Form.Item className="button-form">
          <Button type="primary" htmlType="submit">
            Submit
          </Button>
        </Form.Item>
      </Form>
    </Modal>
  );
}
